import { motion } from "framer-motion";
import { ArrowUpRight, MessageCircle } from "lucide-react";
import { waLink, scrollToId, WHATSAPP_DEFAULT_MESSAGE } from "../lib/site";

export const CTAFinal = ({ phone }) => (
  <section data-testid="cta-final-section" className="noise relative overflow-hidden bg-glg-blue py-20 sm:py-28">
    <div className="pointer-events-none absolute -right-20 -top-20 h-80 w-80 rounded-full bg-white/10 blur-[100px]" />
    <div className="pointer-events-none absolute -bottom-24 -left-10 h-80 w-80 rounded-full bg-glg-orange/30 blur-[120px]" />
    <div className="relative z-10 mx-auto flex max-w-5xl flex-col items-center px-5 text-center sm:px-8">
      <motion.h2
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="font-heading text-3xl font-bold leading-tight tracking-tight text-white sm:text-5xl"
      >
        ¿Tienes un proyecto en mente?
      </motion.h2>
      <motion.p
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6, delay: 0.1 }}
        className="mt-4 max-w-xl text-base text-white/85 sm:text-lg"
      >
        Cuéntanos qué necesitas y diseñemos juntos la solución adecuada.
      </motion.p>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6, delay: 0.2 }}
        className="mt-9 flex flex-col gap-3 sm:flex-row"
      >
        <button
          onClick={() => scrollToId("#contacto")}
          data-testid="cta-final-quote-btn"
          className="group inline-flex items-center justify-center gap-2 rounded-full bg-white px-7 py-4 text-sm font-semibold text-glg-blue transition-transform duration-200 hover:scale-[1.03]"
        >
          Solicitar cotización
          <ArrowUpRight className="h-4 w-4" />
        </button>
        <a
          href={waLink(WHATSAPP_DEFAULT_MESSAGE, phone)}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="cta-final-whatsapp-btn"
          className="inline-flex items-center justify-center gap-2 rounded-full border border-white/40 px-7 py-4 text-sm font-semibold text-white transition-colors duration-200 hover:bg-white/10"
        >
          <MessageCircle className="h-4 w-4" />
          Hablar por WhatsApp
        </a>
      </motion.div>
    </div>
  </section>
);
